/* eslint-disable @stylistic/padding-line-between-statements */
import {inject, Injectable} from '@angular/core';
import {Order} from '@features/sales/domain/entities/order/order.entity';
import {OrderStore} from './order.store';

@Injectable({providedIn: 'root'})
export class OrderQueryService {
  private readonly orders = inject(OrderStore);

  snapshot(): Order[] {
    return this.orders.state().orders.map((dto) => new Order(dto));
  }

  findById(orderId: string): Order | null {
    const dto = this.orders.state().orders.find((o) => o.id === orderId);
    return dto ? new Order(dto) : null;
  }

  findUnpaid(accountId: string): Order | undefined {
    return this.snapshot().find((o) =>
      o.accountId === accountId &&
      (o.isPending || o.isProcessing)
    );
  }
}
